import {
	requests
}from '../../../../api/agent'

export default {
	getPagedAll   : (params) => requests.getWithParams('/ReAddressType/getPagedAll', params),
	getPaged      : (params) => requests.getWithParams('/ReAddressType/getPaged', params),
	getPagedAudit : (params) => requests.getWithParams('/ReAddressType/getPagedAudit', params),
	getList       : (params) => requests.getWithParams('/ReAddressType/getList', params),
	create        : (params) => requests.post('/ReAddressType/create', params),
	delete        : (params) => requests.getWithParams('/ReAddressType/delete', params),
	update        : (params) => requests.post('/ReAddressType/update', params),
	restore       : (params) => requests.getWithParams('/ReAddressType/restore', params)
}